import { PlusIcon, XIcon } from '@primer/octicons-react';
import { Box, IconButton, Tooltip, UnderlineNav } from '@primer/react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/ui/button';
import TextWithEllipse from '../../components/ui/text-with-ellipse';
import UserAvatar from '../../components/user-avatar';
import { thuPhiTabAction } from '../../state/actions/thu-phi-tab/thuPhiTabAction';
import { RootState } from '../../state/reducers';

const ThuPhiTabs = () => {
    const { tabs, selectedId } = useSelector((x: RootState) => x.thuPhiTab);
    const dispatch = useDispatch();
    return (
        <Box sx={{ width: "100%" }}>
            <UnderlineNav aria-label='tabs' key={tabs.map(x => x.id).join(";")}>
                <UnderlineNav.Item>
                    <Tooltip direction='e' text='Thêm tab mới'>
                        <Button variant='invisible' leadingVisual={PlusIcon} text='Thêm tab mới' onClick={() => {
                            dispatch(thuPhiTabAction.ADD_NEW_TAB(undefined));
                        }} />
                    </Tooltip>
                </UnderlineNav.Item>
                {tabs.map((tab, idx) => {
                    return (
                        <UnderlineNav.Item aria-current={tab.id === selectedId ? "page" : undefined} key={tab.id} id={tab.id} onClick={() => {
                            dispatch(thuPhiTabAction.CHANGEG_SELECTED_TAB(tab.id))
                        }}
                        >
                            <Box sx={{ display: "flex", alignItems: "center", width: "220px" }}>
                                <Box sx={{ mr: 2, mt: 1 }}>
                                    <UserAvatar fullName={tab.title} />
                                </Box>
                                <Box sx={{ width: "150px", flex: 1, overflow: "hidden", whiteSpace: "nowrap", textAlign: "left" }}>
                                    <TextWithEllipse text={tab.title} lineNumber={1} />
                                </Box>
                                <Box sx={{ m: 0, mt: -3, mb: -3, mr: 0 }}>
                                    <IconButton aria-label='delete' icon={XIcon}
                                        variant='invisible'
                                        size='small'
                                        onClick={() => {
                                            dispatch(thuPhiTabAction.REMOVE_TAB(tab.id));
                                        }}
                                    />
                                </Box>
                            </Box>
                        </UnderlineNav.Item>
                    );
                })}
            </UnderlineNav>

        </Box>
    );
};

export default ThuPhiTabs;